import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Stack, Typography } from "@mui/material";
import { HtmlEditor } from "../HtmlEditor";
import { useTranslation } from "react-i18next";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export default function DetailDialog({ open, item, onClose, openDatei, filter, user, startDelete }) {
  const { t } = useTranslation();

  if (!item) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          borderRadius: 3,
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          p: 3,
          background: (theme) =>
            `linear-gradient(
            180deg,
            ${theme.palette.primary.main}12 0%,
            transparent 100%
        )`,
        }}
      >
        <Stack spacing={2}>
          {/* Erste Zeile */}
          <Stack direction="row" spacing={2} alignItems="flex-start">
            <Typography
              variant="h5"
              fontWeight={700}
              sx={{
                flex: 1,
                lineHeight: 1.3,
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {item.betreff?.trim()}
            </Typography>

            {item?.ersteller === user?.id && (
              <IconButton color="error" onClick={(e) => startDelete(e, item)}>
                <DeleteIcon />
              </IconButton>
            )}

            <IconButton
              color="primary"
              onClick={onClose}
              sx={{
                flexShrink: 0,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>

          {/* Zweite Zeile */}
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
            <Stack spacing={0.75} flex={1} minWidth={0}>
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Typography variant="body2" color="text.secondary">
                  {item.mandant}
                </Typography>
              </Stack>
            </Stack>

            {item.datei && (
              <Button
                variant="text"
                size="small"
                startIcon={<FolderOpenIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  openDatei(e, item.datei);
                }}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  flexShrink: 0,
                  whiteSpace: "nowrap",
                }}
              >
                {t("Datei öffnen")}
              </Button>
            )}
          </Stack>
        </Stack>
      </DialogTitle>

      <Divider />

      {/* Inhalt */}
      <DialogContent>
        {item.meldung !== "<p></p>" && (
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
            }}
          >
            <Stack spacing={2}>
              <HtmlEditor html={item.meldung} />
            </Stack>
          </Box>
        )}
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          px: 3,
          py: 2,
          justifyContent: "flex-end",
          alignItems: "center",
          background: (theme) =>
            `linear-gradient(
        180deg,
        ${theme.palette.primary.main}12 0%,
        transparent 100%
      )`,
          borderTop: 1,
          borderColor: "divider",
        }}
      >
        {(filter === "Aktiv" || filter === "Inaktiv" || filter === "Zeitlos") && (
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              flexGrow: 1,
              minWidth: 0,
            }}
          >
            <CalendarMonthIcon fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary" sx={{ wordBreak: "break-word" }}>
              {item.zeitlos === "1" ? (
                t("Daueraushang")
              ) : (
                <>
                  {item.vondat}
                  {filter !== "Aktiv" && ` – ${item.bisdat}`}
                </>
              )}
            </Typography>
          </Stack>
        )}

        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            ml: 2,
            flexShrink: 0,
            borderRadius: 2,
            textTransform: "none",
            boxShadow: "none",
          }}
        >
          {t("Schließen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
